import ContractBian from './index';
import SymbolConfig from './symbolConfig';
import TransferRecord from './transferRecord';
import TransferStatistics from './transferStatistics';
import OrderRecord from './orderRecord';
import UserBalance from './userBalance';
import BnBalance from './bnBalance';

export default {
    path: '/home/contractBian',
    component: ContractBian,
    children: [
        {path: '/home/contractBian/symbolConfig', component: SymbolConfig},
        {path: '/home/contractBian/transferRecord', component: TransferRecord},
        {path: '/home/contractBian/transferStatistics', component: TransferStatistics},
        {path: '/home/contractBian/orderRecord', component: OrderRecord},
        {path: '/home/contractBian/userBalance', component: UserBalance},
        {path: '/home/contractBian/bnBalance', component: BnBalance},
    ]
};
